import axios from 'axios';
import config from './config';

export default () => ({
  getCities(data = {}) {
    return new Promise((resolve, reject) => {
      axios.get(config('ENDPOINTS.GET_CITIES'), data)
        .then((response) => {
          if (response.hasOwnProperty('data') && typeof response.data === 'object') {
            resolve(response.data);
            return;
          }

          reject();
        })
        .catch(() => {
          reject();
        });
    });
  },
  getDistricts(data = {}) {
    return new Promise((resolve, reject) => {
      axios.get(config('ENDPOINTS.GET_DISTRICTS'), data)
        .then((response) => {
          if (response.hasOwnProperty('data') && typeof response.data === 'object') {
            resolve(response.data);
            return;
          }

          reject();
        })
        .catch(() => {
          reject();
        });
    });
  },
  submitForm(formData = {}) {
    return new Promise((resolve, reject) => {
      axios.post(config('ENDPOINTS.SUBMIT_SEARCH'), formData)
        .then((response) => {
          resolve({
            response,
            message: 'Wiadomość została wysłana',
          });
        })
        .catch((response) => {
          reject({
            response,
            message: 'Błąd wysyłania wiadomości',
          });
        });
    });
  },
  async getPropertyMedia(id, resource) {
    try {
      const baseUrl = config('ENDPOINTS.GET_GALLERY');
      const response = await axios.get(`${baseUrl}`, { params: { id, resource } });

      return {
        gid: `${resource}_${id}`,
        media: response.data.map((item) => ({
          id: item.id,
          src: item.src,
          thumbnail: item.thumbnail,
          w: item.w,
          h: item.h,
          isVideo: !!item.isVideo,
          videoURL: item.videoURL || null,
        })),
      };
    } catch (e) {
      console.error('Unable to fetch images', {
        id,
        error: e,
      });
      return [];
    }
  },
  async getMarkers({
    count,
    region,
    city,
    country = 'pl',
  }) {
    try {
      const baseUrl = config('ENDPOINTS.GET_MARKERS');
      const response = await axios.get(baseUrl, {
        params: {
          count,
          region,
          city,
          country,
        },
      });

      return response.data;
    } catch (e) {
      console.error('Unable to fetch markers', {
        error: e,
      });
      return [];
    }
  },
  vote({
    direction,
    itemId,
    featureId,
    hasVotedUp,
    hasVotedDown,
  }) {
    return axios.post(config('ENDPOINTS.VOTE'), {
      direction,
      itemId,
      featureId,
      hasVotedUp,
      hasVotedDown,
    });
  },
});
